// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const PublishingConfig = {
    github: (value) => {
        return Object.assign(Object.assign({}, value), { type: "github", _visit: function (visitor) {
                return FernIr.PublishingConfig._visit(this, visitor);
            } });
    },
    direct: (value) => {
        return Object.assign(Object.assign({}, value), { type: "direct", _visit: function (visitor) {
                return FernIr.PublishingConfig._visit(this, visitor);
            } });
    },
    filesystem: (value) => {
        return Object.assign(Object.assign({}, value), { type: "filesystem", _visit: function (visitor) {
                return FernIr.PublishingConfig._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "github":
                return visitor.github(value);
            case "direct":
                return visitor.direct(value);
            case "filesystem":
                return visitor.filesystem(value);
            default:
                return visitor._other(value);
        }
    },
};
